/** Default icon + Italian title for each built-in section type. */
export const SECTION_DEFAULTS = {
    overview: { title: 'Panoramica', icon: '📖' },
    rooms: { title: 'Stanze & Mappa', icon: '🗺️' },
    characters: { title: 'Personaggi', icon: '🛡️' },
    npcs: { title: 'PNG', icon: '🎭' },
    clues: { title: 'Indizi & Diari', icon: '📜' },
    items: { title: 'Oggetti', icon: '🗝️' },
    bestiary: { title: 'Bestiario', icon: '🐉' },
    encounters: { title: 'Incontri', icon: '⚔️' },
    initiative: { title: 'Iniziativa', icon: '⏱️' },
    notes: { title: 'Note del DM', icon: '🗒️' },
    curses: { title: 'Maledizioni', icon: '🩸' },
    gallery: { title: 'Galleria', icon: '🖼️' },
};
/** The order built-in sections appear in when auto-generated. */
const SECTION_ORDER = [
    'overview',
    'rooms',
    'characters',
    'npcs',
    'clues',
    'items',
    'bestiary',
    'encounters',
    'initiative',
    'notes',
    'curses',
    'gallery',
];
/** Whether an adventure has any content for a given built-in section type. */
function hasContentFor(adv, type) {
    switch (type) {
        case 'overview':
            return true;
        case 'rooms':
            return (adv.rooms?.rooms?.length ?? 0) > 0;
        case 'characters':
            return (adv.characters?.length ?? 0) > 0;
        case 'npcs':
            return (adv.npcs?.length ?? 0) > 0;
        case 'clues':
            return (adv.clues?.length ?? 0) > 0;
        case 'items':
            return (adv.items?.length ?? 0) > 0;
        case 'bestiary':
            return (adv.monsters?.length ?? 0) > 0;
        case 'encounters':
            return (adv.encounters?.length ?? 0) > 0;
        // Always-available tools (no source content required):
        case 'initiative':
            return true;
        case 'notes':
            return true;
        case 'gallery':
            return true;
        case 'curses':
            return !!adv.curses && (adv.curses.curses?.length ?? 0) > 0;
        default:
            return false;
    }
}
/**
 * Build the default section list for an adventure based on which content it has.
 * Used by the migration and by "create adventure". The result can then be edited
 * (toggled/reordered) and stored on the adventure.
 */
export function buildDefaultSections(adv) {
    return SECTION_ORDER.filter((type) => hasContentFor(adv, type)).map((type, idx) => {
        const def = SECTION_DEFAULTS[type];
        return {
            id: type,
            type,
            title: def.title,
            icon: def.icon,
            enabled: true,
            order: idx,
        };
    });
}
/** Sorted, enabled-only sections for nav rendering. */
export function visibleSections(sections) {
    return [...sections]
        .filter((s) => s.enabled !== false)
        .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}
//# sourceMappingURL=sections.js.map